import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';

interface PROPS {
  field: FIELD__base;
}

export function G_TABLE_CELL__store_family({ field }: PROPS) {
  return <span className="font-mono">{field.meta.store__get_family()}</span>;
}
